import React, { useCallback } from "react";
import { postMissingDocumentsExport } from "api";
import { ExportButton } from "components";
import { DefaultObjectProps } from "../../types";

interface MissingDocumentsExportButtonProps {
  defaultObject: React.MutableRefObject<DefaultObjectProps>;
}

export const MissingDocumentsExportButton = ({
  defaultObject,
}: MissingDocumentsExportButtonProps) => {
  const handleExport = useCallback(() => {
    const {
      siteIds,
      utilityTypeIds,
      fromDate,
      toDate,
      businessUnits,
      countryRegions,
      countries,
      onlyMissing,
      collectorStatuses,
    } = defaultObject.current;
    return postMissingDocumentsExport({
      siteIds,
      utilityTypeIds,
      fromDate,
      toDate,
      businessUnits,
      countryRegions,
      countries,
      onlyMissing,
      collectorStatuses,
    });
  }, [defaultObject]);

  return (
    <ExportButton
      exportFunction={handleExport}
      exportTitle="check-missing"
      exportText="Export Excel"
      isZipFile={false}
      sx={{ width: "176px" }}
    />
  );
};
